export default __webpack_public_path__ + "static/Plots0109-d7370134250becb0d8ed8b9723353a0f.jpg";